<template>
  <section class="mock-exams-panel" aria-labelledby="mock-exams-heading">
    <div class="mock-exams-panel__decor" aria-hidden="true">
      <svg class="leaf leaf--1" viewBox="0 0 48 64" fill="none">
        <path d="M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z" fill="#A5B94F" opacity="0.55" />
        <path d="M24 8v46" stroke="#8FA03E" stroke-width="1.5" stroke-linecap="round" opacity="0.5" />
      </svg>
      <svg class="leaf leaf--2" viewBox="0 0 48 64" fill="none">
        <path d="M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z" fill="#A5B94F" opacity="0.45" />
        <path d="M24 8v46" stroke="#8FA03E" stroke-width="1.5" stroke-linecap="round" opacity="0.4" />
      </svg>
      <svg class="leaf leaf--3" viewBox="0 0 48 64" fill="none">
        <path d="M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z" fill="#A5B94F" opacity="0.5" />
        <path d="M24 8v46" stroke="#8FA03E" stroke-width="1.5" stroke-linecap="round" opacity="0.45" />
      </svg>
    </div>

    <div class="container">
      <div class="mock-exams-panel__topbar">
        <button
          type="button"
          class="mock-exams-panel__back"
          aria-label="بازگشت به داشبورد"
          @click="goBack"
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M5 12H19" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>بازگشت</span>
        </button>

        <ProfileMenu />
      </div>

      <header class="mock-exams-panel__header">
        <p class="mock-exams-panel__eyebrow">آزمون شبیه‌ساز</p>
        <h1 id="mock-exams-heading" class="mock-exams-panel__title">کتاب و آزمون مورد نظرت رو انتخاب کن</h1>
        <p class="mock-exams-panel__subtitle">
          از میان کتاب‌های کمبریج، آزمون دلخواهت رو شروع کن و پیشرفتت رو دنبال کن.
        </p>
      </header>

      <MockExamPage />
    </div>
  </section>
</template>

<script lang="ts">
import MockExamPage from "../components/pages/MockExamPage.vue";
import ProfileMenu from "@/components/ProfileMenu.vue";

export default {
  components: {
    MockExamPage,
    ProfileMenu,
  },
  methods: {
    goBack() {
      const hasHistory = window.history.state && window.history.state.back;
      if (hasHistory) {
        this.$router.back();
      } else {
        this.$router.push("/dashboard");
      }
    },
  },
};
</script>

<style scoped>
.mock-exams-panel {
  --color-primary: #6D5EF8;
  --color-secondary: #6A4328;
  --color-bg: #FCF9F6;
  --color-card: #FFFFFF;
  --color-border: #ECE4D9;
  --color-text: #4C372A;
  --color-muted: #8C8176;

  position: fixed;
  inset: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--color-bg);
  padding: 56px 0 80px;
  font-family: Vazirmatn, system-ui, "Segoe UI", Tahoma, sans-serif;
  box-sizing: border-box;
}

.mock-exams-panel__decor {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.leaf {
  position: absolute;
  width: 36px;
  height: 48px;
}

.leaf--1 { top: 8%; right: 42%; width: 42px; height: 56px; transform: rotate(25deg); }
.leaf--2 { top: 38%; left: 6%; width: 34px; height: 46px; transform: rotate(-40deg); }
.leaf--3 { top: 58%; left: 14%; width: 28px; height: 38px; transform: rotate(55deg); }

.mock-exams-panel > .container {
  position: relative;
  z-index: 1;
  direction: rtl;
  max-width: 1100px;
  box-sizing: border-box;
  padding-inline: 16px;
}

.mock-exams-panel__topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 28px;
}

.mock-exams-panel__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--color-card);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  padding: 9px 18px;
  border-radius: 999px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(76, 55, 42, 0.06);
  transition: background-color 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.mock-exams-panel__back svg {
  flex-shrink: 0;
}

.mock-exams-panel__back:hover {
  background: #f5f3ff;
  border-color: var(--color-primary);
  transform: translateX(2px);
}

.mock-exams-panel__back:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(109, 94, 248, 0.25);
}

.mock-exams-panel__header {
  margin-bottom: 32px;
}

.mock-exams-panel__eyebrow {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-secondary);
  margin: 0 0 8px;
}

.mock-exams-panel__title {
  margin: 0 0 10px;
  font-size: 30px;
  font-weight: 700;
  color: var(--color-text);
  line-height: 1.35;
}

.mock-exams-panel__subtitle {
  margin: 0;
  font-size: 15px;
  color: var(--color-muted);
  line-height: 1.7;
  max-width: 620px;
}

@media (max-width: 767.98px) {
  .mock-exams-panel__title {
    font-size: 24px;
  }
}
</style>
